const AUTH_TOKEN_KEY = 'auth_token';
const SUBSCRIPTION_ACTIVE_KEY = 'subscription_active';

const dispatchAuthChange = () => window.dispatchEvent(new Event('auth-change'));
const dispatchSubscriptionChange = () => window.dispatchEvent(new Event('subscription-change'));

export const authStorage = {
  getToken() {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  },
  hasToken() {
    return Boolean(localStorage.getItem(AUTH_TOKEN_KEY));
  },
  hasActiveSubscription() {
    return localStorage.getItem(SUBSCRIPTION_ACTIVE_KEY) === 'true';
  },
  setToken(token: string) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    localStorage.setItem(SUBSCRIPTION_ACTIVE_KEY, 'false');
    dispatchAuthChange();
    dispatchSubscriptionChange();
  },
  setSubscriptionActive(isActive: boolean) {
    localStorage.setItem(SUBSCRIPTION_ACTIVE_KEY, String(isActive));
    dispatchSubscriptionChange();
  },
  clearToken() {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(SUBSCRIPTION_ACTIVE_KEY);
    dispatchAuthChange();
    dispatchSubscriptionChange();
  },
};
